var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"flex items-center h-full"},[_c('feather-icon',{attrs:{"icon":"EyeIcon","svgClasses":"h-5 w-5 hover:text-primary cursor-pointer"},on:{"click":_vm.onView}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }